import '@/cart';
import EventBus from '@/event-bus';
import Products from '@/products';
import _Singleton from '@/tools/singleton';
import jquery from 'jquery';
import createDateFromString from '@/helpers/createDateFromString';
import haveSameKeys from '@/helpers/haveSameKeys';
import getProductAccessoriesData from '@/helpers/getProductAccessoriesData';
import getCartItemAccessoriesData from '@/helpers/getCartItemAccessoriesData';

// lodash
import _cloneDeep from 'lodash/cloneDeep';
import _debounce from 'lodash/debounce';
import _filter from 'lodash/filter';
import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import _merge from 'lodash/merge';
import _round from 'lodash/round';
import _sum from 'lodash/sum';
import _toFinite from 'lodash/toFinite';
import _toInteger from 'lodash/toInteger';
import _toNumber from 'lodash/toNumber';

import options from '@/ui/ui_cart/default-selectors.json';
import defaultSettings from '@/ui/ui_cart/default-settings.json';

/** @private */
const AWAIT_TIME = 200;
/**
 * Связка с DOM
 * @memberof Cart
 * @class
 *
 * @alias Cart.ui
 * @private
 */

const CartDOM = function() {
  const self = this;

  self.options = options;
  self.defaultSettings = defaultSettings;
  self._init();
};

/**
 * Инициализация
 * @method
 * @private
 *
 * @return {void}
 */
CartDOM.prototype._init = function() {
  const self = this;

  // Прибиваем все обработчики
  self._bindDeleteItem();
  self._bindClearOrder();

  document.addEventListener('DOMContentLoaded', function() {
    self._bindAddItem();
    self._bindCoupon();
    self._bindAjaxCart();
    self._bindUpdateCart();
    self._bindCheckout();
    self._sharedCart();
  });

  EventBus.subscribe('update_items:insales:cart:light', function(cartData) {
    jquery(self.options.itemCount.attr).html(cartData.order_lines.length);

    self.setPositionsCount(cartData);
    self.setTotalPrice(cartData);
    self.setFullTotalPrice(cartData);
    self.setWarehouseTotalWeight(cartData);
    self.setBnplPrices(cartData);
    self.setPricesForWarehouseItems(cartData);
    self.setPricesForOrderLines(cartData);
    self.setFullTotalOldPrice(cartData);
  });

  return;
};

/**
 * Установка настроек
 * @method
 * @private
 *
 * @param {Object} optionsData - Объект с настройками
 *
 * @return {void}
 */
CartDOM.prototype.setConfig = function(optionsData) {
  const self = this;

  _merge(self.options, optionsData);

  return;
};

/**
 * Добавляем товары из формы
 * @method
 * @private
 *
 * @param {jQuery-Object} $button - кнопка
 *
 * @return {void}
 */
CartDOM.prototype._addItem = function($button) {
  const self = this;
  const $form = $button.parents('form:first');
  const task = self._parseProductForm($form, $button);

  window.InsalesCommonCart.add(task);

  return;
};

/**
 * Обработка добавления товара в корзину
 * @method
 * @private
 *
 * @return {void}
 */
CartDOM.prototype._bindAddItem = function() {
  const self = this;

  jquery(document).on('click', self.options.add.attr, function(event) {
    event.preventDefault();
    const $button = jquery(this);

    if (!$button.prop(self.options.inProcess.value)) {
      // если эту кнопку еще не жали
      if (!$button.prop(self.options.disabled.value)) {
        // если кнопка не заблочена - делаем добавление
        // вешаем на кнопку метку "В обработке"
        $button.prop(self.options.inProcess.value, true);
        self._addItem($button);
      } else {
        // иначе - дергаем событие
        EventBus.publish('add_disabled:insales:product', { button: $button });
      }
    }
  });

  // снимаем с кнопки метку после операций с корзиной
  EventBus.subscribe('always:insales:cart', function(eventData) {
    self._unlockButton(eventData, 'add_items');
  });
};

/**
 * Удаляем один вариант из корзины по клику на кнопке "Удалить". Если у варианта есть опции, то удаляем только этот вариант с опциями
 * @method
 * @private
 *
 * @param {jQuery} [$button] - кнопка
 *
 * @return {void}
 */
CartDOM.prototype._deleteItem = function($button) {
  const self = this;
  const $form = $button.parents('form:first');
  const warehouse_id = $form.data('warehouseId');
  const variantId = self._getId($button.attr(self.options.delete.value));

  let items = [ variantId ];

  const itemNode = $button.parents(self.options.itemId.attr)[0];
  const accessoriesData = getCartItemAccessoriesData(itemNode);

  if (Object.keys(accessoriesData).length) {
    items = {};

    items.accessoriable_variant_ids = {};
    items.accessoriable_variant_ids[variantId] = [{
      quantity: 0,
      accessory_value_ids: accessoriesData
    }];
  }

  const task = {
    items,
    button: $button,
    prevStateCart: _cloneDeep(window.InsalesCommonCart.order),
    warehouse_id
  };

  jquery.each(window.InsalesCommonCart.order.order_lines, function(index, el) {
    if (el.id === variantId && haveSameKeys(el.accessory_value_ids, accessoriesData)) {
      task.product_id = el.product_id;
      task.quantity = el.quantity;
      task.variant_id = el.id;
    }
  });

  // посылаем данные в корзину
  window.InsalesCommonCart.delete(task);

  return;
};

/**
 * Обработка удаления товара из корзины
 * @method
 * @private
 *
 * @return {void}
 */
CartDOM.prototype._bindDeleteItem = function() {
  const self = this;

  jquery(document).on('click', self.options.delete.attr, function(event) {
    event.preventDefault();
    const $button = jquery(this);

    if (!$button.prop(self.options.inProcess.value)) {
      // Вешаем метку "в процессе"
      $button.prop(self.options.inProcess.value, true);
      self._deleteItem($button);
    }
  });

  // Снимаем метку "в процессе" с кнопки
  EventBus.subscribe('always:insales:cart', function(eventData) {
    self._unlockButton(eventData, 'delete_items');
  });
};

/**
 * Пересчет корзины из формы
 * @method
 *
 * @param {jQuery} [$button] - Конпка, которая вызвала все это, необязательный параметр
 * @param {jQuery} [form] - Форма, из которой тянем данные, необязательный параметр
 *
 * @return {void}
 */
CartDOM.prototype.updateOrder = function($button, form) {
  const self = this;
  const $form = (form && form.length) ? form : jquery(self.options.form.attr);
  const warehouse_id = $form.data('warehouseId');
  const $fields = $form.find('input[name*="cart[quantity]"]');

  const task = {
    items: {},
    form: $form,
    coupon: self._getCoupon($form),
    prevStateCart: _cloneDeep(window.InsalesCommonCart.order),
    warehouse_id
  };

  if ($button && $button.length != 0) {
    task.button = $button;
  }

  task.items = self._getItems($fields);

  const newPosition = _filter(task.items, function(item, key) {
    // Если есть айтемы с опциями, то корзина сама разберётся надо ли их добавлять. Проверять это здесь излишне.
    if (key === 'accessoriable_variant_ids') {
      return true;
    }

    const variantId = _toNumber(key);
    let order_lines = window.InsalesCommonCart.order.order_lines;
    let newItem = false;

    if (warehouse_id && window.InsalesCommonCart.order.multi_orders) {
      order_lines = window.InsalesCommonCart.order.multi_orders[warehouse_id].items;
    }

    _forEach(order_lines, (value, i) => {
      if (variantId === value.id) {
        newItem = value.quantity !== task.items[key];
      }
    });

    return newItem;
  });

  const oldCoupon = (window.InsalesCommonCart.order.coupon) ? window.InsalesCommonCart.order.coupon.value : false;
  const newCoupon = (oldCoupon || task.coupon) ? (oldCoupon !== task.coupon) : false;

  if (newCoupon || newPosition.length) {
    window.InsalesCommonCart.set(task);
  }

  return;
};

/**
 * Обновление корзины
 * @method
 * @private
 *
 * @return {void}
 */
CartDOM.prototype._bindUpdateCart = function() {
  const self = this;
  const $forms = jquery(self.options.form.attr);

  $forms.not(self.options.formInited.attr).each(function() {
    const $form = jquery(this);

    $form.attr(self.options.formInited.value, true);

    // обработчик нажатия enter в форме корзины
    $form.on('keypress', $form, function(event) {
      if (event.key !== 'Enter') { return; }

      // блочим отправку формы и запускаем обработку
      event.preventDefault();
      self.updateOrder(jquery(event.target));
    });

    jquery(document).on('click', self.options.update.attr, function(event) {
      event.preventDefault();

      const $button = jquery(this);

      if (!$button.prop(self.options.inProcess.value)) {
        $button.prop(self.options.inProcess.value, true);
        self.updateOrder($button);
      }
    });

    // снимаем метку "в процессе" с кнопки
    EventBus.subscribe('always:insales:cart', function(eventData) {
      self._unlockButton(eventData, 'set_items');
    });

    // Слушаем изменение кол-ва товара в корзине
    // есть ли она?
    if ($form.length) {
      // подписываемся на событие
      EventBus.subscribe('change_quantity:insales:item', function(eventData) {
        // а оно было в форме?
        if (eventData.action.product.closest($form).length) {
          // все ок, пинаем
          const _form = jquery(eventData.action.product).parents('[data-cart-form]');

          self.updateOrder(null, _form);
        }
      });
    }
  });
};

/**
 * Очистить корзину (через форму)
 * @method
 *
 * @param {jQuery} [$button] - Конпка, которая вызвала все это, необязательный параметр
 *
 * @return {void}
 */
CartDOM.prototype.clearOder = function($button) {
  const self = this;
  const $form = jquery(self.options.form.attr);
  const warehouse_id = $form.data('warehouseId');
  const $fields = $form.find('input[name*="cart[quantity]"]');

  const task = {
    items: [],
    form: $form,
    isClear: true,
    warehouse_id
  };

  // вешаем метку на кнопку, добавляем ее в таску
  if ($button && $button.length != 0) {
    task.button = $button;
  }

  task.items = _keys(self._getItems($fields));

  window.InsalesCommonCart.delete(task);

  return;
};

/**
 * Обработка полной очистки корзины
 * @method
 * @private
 *
 * @return {void}
 */
CartDOM.prototype._bindClearOrder = function() {
  const self = this;

  jquery(document).on('click', self.options.clear.attr, function(event) {
    event.preventDefault();
    const $button = jquery(this);

    if (!$button.prop(self.options.inProcess.value)) {
      $button.prop(self.options.inProcess.value, true);
      self.clearOder($button);
    }
  });

  // снимаем метку "в процессе" с кнопки
  EventBus.subscribe('always:insales:cart', function(eventData) {
    self._unlockButton(eventData, 'delete_items');
  });
};

/**
 * Отправка купона
 * @method
 *
 * @param {jQuery} $form - форма, из которой тянем поле с купоном
 * @param {jQuery} [$button] - кнопка, которая вызвала все это, необязательный параметр
 *
 * @return {void}
 */
CartDOM.prototype.setCoupon = function($form, $button) {
  const self = this;
  const warehouse_id = $form.data('warehouseId');
  const task = {
    items: {},
    form: $form,
    coupon: self._getCoupon($form),
    button: $button,
    warehouse_id
  };

  window.InsalesCommonCart.setCoupon(task);

  return;
};

/**
 * Обработчики работы с купоном
 * @method
 * @private
 *
 * @return {void}
 */
CartDOM.prototype._bindCoupon = function() {
  const self = this;

  // вешаем глобальный обработчик
  jquery(document).on('click', self.options.coupon.attr, function(event) {
    event.preventDefault();
    const $button = jquery(this);

    self.setCoupon($button.parents('form:first'), $button);
  });

  jquery(document).on('keypress', '[name="cart[coupon]"]', function(event) {
    if (event.key !== 'Enter') { return; }

    event.stopPropagation();
    event.preventDefault();

    self.setCoupon(jquery(this).parents('form:first'));
  });

  // снимаем метку "в процессе" с формы
  EventBus.subscribe('always:insales:cart', function(eventData) {
    self._unlockButton(eventData, 'set_coupon');
  });

  EventBus.subscribe('update_items:insales:cart:light', function(eventData) {
    const discounts = eventData.discounts || [];
    const withDiscounts = discounts.length > 0;

    jquery(self.options.discounts.attr)
      .data(self.options.discounts.value, withDiscounts)
      .attr(self.options.discounts.value, withDiscounts);

    jquery(self.options.discounts.attr)
      .html(self._getDiscounts(discounts));

    jquery(self.options.discountsDescriptionValue.attr)
      .data(self.options.discountsDescriptionValue.value, withDiscounts)
      .attr(self.options.discountsDescriptionValue.value, withDiscounts);

    jquery(self.options.discountsDescriptionValue.attr).html(self._getDiscounts(discounts));

    if (eventData.errors.length) {
      jquery(self.options.discountsError.attr).attr(self.options.discountsError.value, true);

      jquery(self.options.discountsError.attr).html(self._getErrorDiscounts(eventData.errors));

      if (withDiscounts) {
        jquery(self.options.discounts.attr).append(self._getErrorDiscounts(eventData.errors));
      } else {
        jquery(self.options.discounts.attr).html(self._getErrorDiscounts(eventData.errors));
      }

      return;
    }

    jquery(self.options.discountsError.attr).attr(self.options.discountsError.value, false);
    jquery(self.options.discountsError.attr).html('');
  });

  // прогружаем верстку
  EventBus.subscribe('set_coupon:insales:cart', function(eventData) {
    const $form = _get(eventData, 'action.form', jquery({}));
    const reloadOnCoupon = ($form.is(self.options.reloadCoupon.attr)) ? $form.data(self.options.reloadCoupon.value) : self.options.reloadOnCoupon;

    if ($form.is(self.options.form.attr)) {
      if (reloadOnCoupon) {
        document.location.reload();
      } else {
        console.warn('Вы отключили атвоматическое обновление страницы корзины после применения купона. Создайте свой обработчик по событию шины "set_coupon:insales:cart"'); // eslint-disable-line max-len
      }
    }
  });

  return;
};

/**
 * Вытаскиваем id из строки
 * @method
 * @private
 *
 * @param {String} string - name поля ввода.
 *
 * @return {Number} Id товара
 */
CartDOM.prototype._getId = function(string) {
  return _toInteger(string.replace(/\D+/g, ''));
};

/**
 * Собираем скидки
 * @method
 * @private
 * @param {Array} discounts - массив скидок
 * @return {String} html
 */
CartDOM.prototype._getDiscounts = function(discounts = []) {
  const $content = jquery('<div />', { 'class': 'insales-ui-discounts' });
  _forEach(discounts, function(discount) {
    $content
    .append(
      jquery('<div />', { 'class': 'insales-ui-discount-item' })
      .append(jquery('<div />', {
        'class': 'insales-ui-discount-description',
        html: discount.description
      }))
      .append(jquery('<div />', {
        'class': 'insales-ui-discount-amount',
        html: window.Shop.money.format(discount.amount)
      }))
    );
  });

  return (discounts.length) ? $content.wrapAll('<div>').parent().html() : '';
};

/**
 * Собираем ошибки
 * @method
 * @private
 * @param {Array} errors - массив ошибок
 * @return {String} html
 */
CartDOM.prototype._getErrorDiscounts = function(errors = []) {
  const $content = jquery('<div />', { 'class': 'insales-ui-discounts-errors' });
  _forEach(errors, function(errorText) {
    $content
      .append(
        jquery('<div />', {
          'class': 'insales-ui-discount-error',
          html: errorText
        }));
  });

  return (errors.length) ? $content.wrapAll('<div>').parent().html() : '';
};

/**
 * Собираем items из $fields
 * @method
 * @private
 * @param {jQuery} $fields - поля формы
 * @return {Object} items
 */
CartDOM.prototype._getItems = function($fields) {
  const self = this;
  const items = {};

  $fields.each(function(index, item) {
    const $item = jquery(item);

    const product = item.closest(self.options.itemId.attr);

    const accessoriesData = getCartItemAccessoriesData(product);

    if (Object.keys(accessoriesData).length) {
      items.accessoriable_variant_ids = items.accessoriable_variant_ids || {};

      items.accessoriable_variant_ids[self._getId($item.attr('name'))] = items.accessoriable_variant_ids[self._getId($item.attr('name'))] || [];

      items.accessoriable_variant_ids[self._getId($item.attr('name'))].push({
        quantity: parseFloat($item.val()),
        accessory_value_ids: accessoriesData
      });

      return;
    }

    items[self._getId($item.attr('name'))] = parseFloat($item.val());
  });

  return items;
};

/**
 * Получаем значения из поля для ввода купона
 * @method
 * @private
 * @param {jQuery} $form - форма
 * @return {String|Boolean} coupon || false
 */
CartDOM.prototype._getCoupon = function($form) {
  return $form.find('[name="cart[coupon]"]').val() || false;
};

/**
 * Снимаем метку "в процессе" с кнопки
 * @method
 * @private
 * @param {Object} eventData - данные события
 * @param {String} eventName - название события
 * @return {void}
 */
CartDOM.prototype._unlockButton = function(eventData, eventName) {
  const self = this;
  const _button = eventData.action && eventData.action.button;

  if (_button && eventData.action.method === eventName) {
    _button.prop(self.options.inProcess.value, false);
  }
};

/**
 * Получаем комментарии к товарам
 * @method
 * @private
 *
 * @param {jQuery} $form - форма
 * @return {Object} - Объект с комментариями
 */
CartDOM.prototype._getComments = function($form) {
  const self = this;
  const commentsObject = {};
  const $comments = $form.find('[name*="cart[order_line_comments]"]');

  $comments.each(function() {
    var $comment = jquery(this);

    commentsObject[self._getId($comment.attr('name'))] = $comment.val();
  });

  return commentsObject;
};

/**
 * Разбираем форму товара
 * @method
 * @private
 *
 * @param {jQuery} $form - форма
 * @param {jQuery} [$button] - кнопка
 *
 * @return {Object} - Таск с данными
 */
CartDOM.prototype._parseProductForm = function($form, $button) {
  const self = this;
  const warehouse_id = $form.data('warehouseId');
  const $fields = $form.find('[name*="variant_ids"]');
  const $one_variant = $form.find('[name="variant_id"]').first();
  const $quantity = $form.find('input[name="quantity"]:not([data-option-id], [data-value-id], [data-option-bind])').first();
  const $comment = $form.find('[name="comment"]');
  const _$button = $button || {};
  const accessoriesData = getProductAccessoriesData($form.get(0));

  if ($form.find('[name="variant_id"]').length > 1) {
    console.warn('Задвоение name="variant_id"', $form.find('[name="variant_id"]'));
  }
  if ($quantity.length > 1) {
    console.warn('Задвоение name="quantity"', $form.find('[name="quantity"]:not([data-option-id], [data-value-id], [data-option-bind])'));
  }

  const task = {
    items: {},
    comments: {},
    button: $button,
    form: $form,
    coupon: self._getCoupon($form),
    isQuickCheckout: _$button.checkoutButton || false,
    warehouse_id
  };

  // складываем данные в объект
  // если в форме был стандартный селектор модификаций, кладем отдельно
  if ($one_variant.length === 1) {
    let quantity = parseFloat($quantity.val()) || 1;

    if (Object.keys(accessoriesData).length) {
      task.items.accessoriable_variant_ids = {};
      task.items.accessoriable_variant_ids[_toInteger($one_variant.val())] = [{
        quantity,
        accessory_value_ids: accessoriesData
      }];
    } else {
      task.items[_toInteger($one_variant.val())] = quantity;
    }

    task.comments[_toInteger($one_variant.val())] = $comment.val();

    if ($form.find('[name="variant_id"]').length === 0) {
      console.warn('Отсутствует name="variant_id"', $form);
    }
    if ($form.find('[name="quantity"]').length === 0) {
      console.warn('Отсутствует name="quantity"', $form);
    }
  }

  _merge(task.items, self._getItems($fields));

  _merge(task.comments, self._getComments($form));

  return task;
};

/**
 * @method
 * @param {jquery} $node - jquery элемент корзины с атрибутом data-ajax-cart
 * @description
 * Метод для инициализации формы корзины (доступен в InSalesUI)
 *
 * @return {void}
 */
CartDOM.prototype.initAjaxInstance = function($node) {
  const self = this;
  const $form = $node.parent().find(self.options.ajaxCart.attr);

  setTimeout(function() {
    const $products = $form.find('[data-product-id]');

    $products.each(function() {
      Products.initInstance(jquery(this));
    });
    EventBus.publish('after:insales:initAjaxInstance', {});
  }, 0);
};

/**
 * @private
 *
 * @description
 * Инициализация ajax корзины
 *
 * @return {void}
 */
CartDOM.prototype._bindAjaxCart = function() {
  const self = this;

  jquery(document).on('change_quantity:insales',
    self.options.ajaxCart.attr,
    _debounce(function(event) {
      const $product = jquery(event.target);
      const $form = $product.closest(self.options.ajaxCart.attr);
      const warehouse_id = $form.data('warehouseId');
      const $fields = $form.find('input[name*="cart[quantity]"]');
      const _items = self._getItems($fields);

      window.InsalesCommonCart.set({
        items: _items,
        form: $form,
        warehouse_id
      });
    }, AWAIT_TIME));
};

/**
 * @private
 *
 * @description
 * Получение текста из словаря базовых настроек
 *
 * @param {String} messageName - Название сообщения
 *
 * @return {String} - Текст сообщения
 */
CartDOM.prototype._getMessageByLocale = function(messageName) {
  const self = this;

  if (typeof self.locale !== 'undefined') {
    let result_message = self.settings[messageName][self.locale];

    if (typeof result_message === 'undefined') {
      result_message = self.settings[messageName].ru;
    }

    return result_message;
  }

  return self.settings[messageName].ru;
};

/**
 * @private
 * @param {Object} cartData - Данные корзины
 *
 * @description
 * Вывод кол-ва позиций в корзине и мультикорзине
 *
 * @return {void}
 */
CartDOM.prototype.setPositionsCount = function(cartData) {
  const self = this;
  let positionsCount = null;

  if (cartData.multi_orders) {
    const $positionsCountElements = jquery(self.options.positionsCount.attr);

    $positionsCountElements.each(function() {
      const $cur_positions_count_element = jquery(this);
      const warehouse_id = $cur_positions_count_element.parents('form:first').data('warehouseId');

      if (warehouse_id) {
        positionsCount = 0;

        if (cartData.multi_orders[warehouse_id] && cartData.multi_orders[warehouse_id].items_count) {
          positionsCount = _round(_toFinite(cartData.multi_orders[warehouse_id].items_count), 3);
        }
      } else {
        positionsCount = _round(_toFinite(_sum(_map(cartData.multi_orders, item => _toNumber(item.items_count)))), 3);
      }

      $cur_positions_count_element.html(positionsCount);
    });
  } else {
    positionsCount = _round(_toFinite(cartData.items_count), 3);
    jquery(self.options.positionsCount.attr).html(positionsCount);
  }

  if (positionsCount <= 0) {
    jquery(self.options.positionsCount.attr).addClass(self.defaultSettings.classes.cartEmpty);
  } else {
    jquery(self.options.positionsCount.attr).removeClass(self.defaultSettings.classes.cartEmpty);
  }
};

/**
 * @private
 * @param {Object} cartData - Данные корзины
 *
 * @description
 * Итоговая стоимость всех товаров в корзине или мультикорзине с учётом скидок
 *
 * @return {void}
 */
CartDOM.prototype.setTotalPrice = function(cartData) {
  const self = this;
  const $totalPriceElements = jquery(self.options.totalPrice.attr);

  if (!$totalPriceElements || !$totalPriceElements.length) { return; }

  $totalPriceElements.each(function() {
    const $curElement = jquery(this);
    const warehouseId = $curElement.parents('form:first').data('warehouseId');

    if (warehouseId) {
      let warehouse_total_price = 0;

      if (cartData.multi_orders[warehouseId] && cartData.multi_orders[warehouseId].total_price) {
        warehouse_total_price = cartData.multi_orders[warehouseId].total_price;
      }

      $curElement.html(window.Shop.money.format(warehouse_total_price));
    } else {
      $curElement.html(window.Shop.money.format(cartData.total_price));
    }
  });

  return;
};

/**
 * @private
 * @param {Object} cartData - Данные корзины
 *
 * @description
 * Итоговая стоимость всех товаров в корзине или мультикорзине без учёта скидок
 *
 * @return {void}
 */
CartDOM.prototype.setFullTotalPrice = function(cartData) {
  const self = this;
  const $fullTotalPriceElements = jquery(self.options.fullTotalPrice.attr);

  if (!$fullTotalPriceElements || !$fullTotalPriceElements.length) { return; }

  $fullTotalPriceElements.each(function() {
    const $curElement = jquery(this);
    const warehouseId = $curElement.parents('form:first').data('warehouseId');

    if (warehouseId) {
      let warehouse_items_price = 0;

      if (cartData.multi_orders[warehouseId] && cartData.multi_orders[warehouseId].items_price) {
        warehouse_items_price = cartData.multi_orders[warehouseId].items_price;
      }

      $curElement.html(window.Shop.money.format(warehouse_items_price));
    } else {
      $curElement.html(window.Shop.money.format(cartData.items_price));
    }
  });

  return;
};

/**
 * @private
 * @param {Object} cartData - Данные корзины
 *
 * @description
 * Общий вес всех товаров в мультикорзине
 *
 * @return {void}
 */
CartDOM.prototype.setWarehouseTotalWeight = function(cartData) {
  const self = this;
  const $warehouseTotalWeight = jquery(self.options.warehouseItemsWeight.attr);

  if (!$warehouseTotalWeight || !$warehouseTotalWeight.length) { return; }

  $warehouseTotalWeight.each(function() {
    const $curElement = jquery(this);
    const warehouseId = $curElement.parents('form:first').data('warehouseId');

    if (warehouseId) {
      let warehouse_total_weight = 0;

      if (cartData.multi_orders[warehouseId] && cartData.multi_orders[warehouseId].items_weight) {
        warehouse_total_weight = cartData.multi_orders[warehouseId].items_weight;
      }

      if (!parseFloat(warehouse_total_weight)) {
        $curElement.parents('form:first').addClass(self.defaultSettings.classes.warehouseTotalWeightZero);
      }

      $curElement.html(`${warehouse_total_weight} ${window.Shop.units.getName('kgm')}`);
    }
  });

  return;
};

/**
 * @private
 * @param {Object} cartData - Данные корзины
 * @param {Number} sber_min_price - Минимальная сумма заказа для оплаты частями
 * @param {Number} sber_max_price - Максимальная сумма заказа для оплаты частями
 *
 * @description
 * Вывод цен для оплаты частями
 *
 * @return {void}
 */
CartDOM.prototype.setBnplPrices = function(cartData) {
  const self = this;

  const sber_min_price = window.Shop.config.config.sber_bnpl_min_amount;
  const sber_max_price = window.Shop.config.config.sber_bnpl_max_amount;

  jquery(self.options.sberBnplPay.attr).html(window.Shop.money.format(cartData.sber_bnpl_pay));
  jquery(self.options.sberBnplLastPay.attr).html(window.Shop.money.format(cartData.sber_bnpl_last_pay));
  jquery(self.options.sberBnplLastPayInfo.attr).html(window.Shop.money.format(cartData.sber_bnpl_last_pay_info));

  if (jquery(self.options.sberBnplCart.attr).length) {
    if (cartData.total_price < sber_min_price) {
      jquery(self.options.sberBnplCart.attr).show();
      jquery(self.options.sberBnplCartAvailable.attr).hide();
      jquery(self.options.sberBnplCartNotavailable.attr).show();
      let requirement_total = sber_min_price - cartData.total_price;
      jquery(self.options.sberBnplCartNotavailable.attr)
        .html(`Увеличьте сумму заказа на <b>${window.Shop.money.format(requirement_total)}</b> для оплаты частями.`);
    }

    if (cartData.total_price >= sber_min_price && cartData.total_price <= sber_max_price) {
      jquery(self.options.sberBnplCart.attr).show();
      jquery(self.options.sberBnplCartAvailable.attr).show();
      jquery(self.options.sberBnplCartNotavailable.attr).hide();
    }

    if (cartData.total_price > sber_max_price) {
      jquery(self.options.sberBnplCart.attr).hide();
    }
  }

  jquery(self.options.sberBnplFirstDate.attr).html(createDateFromString(cartData.sber_bnpl_first_date));
  jquery(self.options.sberBnplSecondDate.attr).html(createDateFromString(cartData.sber_bnpl_second_date));
  jquery(self.options.sberBnplThirdDate.attr).html(createDateFromString(cartData.sber_bnpl_third_date));
  jquery(self.options.sberBnplFourthDate.attr).html(createDateFromString(cartData.sber_bnpl_fourth_date));

  return;
};

/**
 * @private
 * @param {Object} cartData - Данные корзины
 *
 * @description
 * Если есть мультикорзины, то выводим цены для каждой позиции каждой корзины
 *
 * @return {void}
 */
CartDOM.prototype.setPricesForWarehouseItems = function(cartData) {
  if (!cartData.multi_orders) { return; }

  const self = this;

  // Создаём словарь для быстрого доступа к айтемам обычной корзины
  const orderLinesMap = new Map(cartData.order_lines.map(item => [ item.id, item ]));

  _forEach(cartData.multi_orders, function(warehouse, warehouse_id) {
    const $warehouse_form = jquery(`[${self.options.warehouseId.value}="${warehouse_id}"]`);

    _forEach(warehouse.items, function(warehouse_item) {
      const $line = $warehouse_form.find(`[${self.options.itemId.value}="${warehouse_item.id}"]`);

      const order_line_item = orderLinesMap.get(warehouse_item.id);

      if (!$line || !$line.length || !order_line_item) { return; }

      const warehouse_total_price = order_line_item.sale_price * warehouse_item.quantity;
      const warehouse_sale_price = order_line_item.sale_price;

      const $itemTotalPrice = $line.find(self.options.itemTotalPrice.attr);
      const $itemPrice = $line.find(self.options.itemPrice.attr);

      $itemTotalPrice.html(window.Shop.money.format(warehouse_total_price));
      $itemPrice.html(window.Shop.money.format(warehouse_sale_price));
    });
  });

  return;
};

/**
 * @private
 * @param {Object} cartData - Данные корзины
 *
 * @description
 * При выводе цен каждой позиции проверяем отфильтровываем их от мульти корзины
 *
 * @return {void}
 */
CartDOM.prototype.setPricesForOrderLines = function(cartData) {
  const self = this;

  jquery(cartData.order_lines).each(function() {
    let $lineNode = jquery(`[${self.options.itemId.value}="${this.id}"]`)
      .filter(function() {
        return !jquery(this).parents('form:first').data('warehouseId');
      });

    if (!$lineNode || !$lineNode.length) { return; }

    if ($lineNode.length > 1) {
      const lineAccessoryValueIds = this.accessory_value_ids || {};

      $lineNode = $lineNode.filter(function() {
        const accessoriesData = getCartItemAccessoriesData(this);

        if (!Object.keys(accessoriesData).length && !Object.keys(lineAccessoryValueIds).length) { return true; }

        return haveSameKeys(accessoriesData, lineAccessoryValueIds);
      });
    }

    const $itemTotalPrice = $lineNode.find(self.options.itemTotalPrice.attr);
    const $itemPrice = $lineNode.find(self.options.itemPrice.attr);

    $itemTotalPrice.html(window.Shop.money.format(this.total_price));
    $itemPrice.html(window.Shop.money.format(this.sale_price));
  });

  return;
};

/**
 * @private
 * @param {Object} cartData - Данные корзины
 *
 * @description
 * Вывод старой цены для каждой позиции
 *
 * @return {void}
 */
CartDOM.prototype.setFullTotalOldPrice = function(cartData) {
  const self = this;
  const $fullTotalOldPriceElements = jquery(self.options.fullTotalOldPrice.attr);
  const $totalSaleElements = jquery(self.options.totalSale.attr);

  if ($fullTotalOldPriceElements.length || $totalSaleElements.length) {
    const productIds = _map(cartData.order_lines, 'product_id');
    Products.getList(productIds).then((products) => {
      let totalOldPrice = 0;
      let totalSale = 0;

      _forEach(cartData.order_lines, (value) => {
        const variantId = value.variant_id;
        const productId = value.product_id;
        const product = products[productId];

        if (product) {
          const variant = product.variants.find((item) => item.id === variantId);
          let currentPrice = value.sale_price;

          if (variant && variant.old_price) {
            currentPrice = variant.old_price;
          }
          totalOldPrice += parseFloat(currentPrice) * value.quantity;
        }
      });

      totalSale = totalOldPrice - cartData.total_price;
      $fullTotalOldPriceElements.html(window.Shop.money.format(totalOldPrice));
      $totalSaleElements.html(window.Shop.money.format(totalSale));

      if (totalSale === 0) {
        jquery(self.options.totalSaleParent.attr).addClass(self.defaultSettings.classes.cartSaleEmpty);
      } else {
        jquery(self.options.totalSaleParent.attr).removeClass(self.defaultSettings.classes.cartSaleEmpty);
      }
    });
  }

  return;
};

/**
 * @method
 * @private
 * @description
 * Если в корзине есть опции, то модифицируем форму перед отправкой. Добавляем поля для опций, а также меняем название поля с кол-вом товара
 *
 * @return {void}
 */
CartDOM.prototype._bindCheckout = function() {
  const self = this;
  const forms = Array.from(document.querySelectorAll(self.options.form.attr));

  forms.forEach(form => {
    const hasAccessories = form.querySelector(self.options.itemAccessories.attr);

    if (!hasAccessories) { return; }

    form.addEventListener('submit', function() {
      const lineNodes = Array.from(form.querySelectorAll(self.options.itemId.attr));

      lineNodes.forEach((lineNode, index) => {
        const variantId = lineNode.dataset.itemId;
        const accessoriesData = getCartItemAccessoriesData(lineNode);

        const quantityInput = lineNode.querySelector('input[name*="cart[quantity]"]');

        if (!quantityInput || !variantId) { return; }

        quantityInput.name = `accessoriable_variant_ids[${variantId}][${index}][quantity]`;

        Object.keys(accessoriesData).forEach(accessoryId => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `accessoriable_variant_ids[${variantId}][${index}][accessory_value_ids][${accessoryId}]`;
          input.value = 1;

          lineNode.appendChild(input);
        });
      });
    });
  });
};

/**
 * @method
 * @private
 * @description
 * Обработка сабмита расшаренной корзины
 *
 * @return {void}
 */
CartDOM.prototype._sharedCart = function() {
  const self = this;

  const forms = Array.from(document.querySelectorAll(self.options.sharedCart.attr));

  forms.forEach(form => {
    form.addEventListener('submit', function(event) {
      event.preventDefault();

      const items = {};
      const lineNodes = Array.from(form.querySelectorAll(self.options.itemId.attr));

      lineNodes.forEach((lineNode) => {
        const variantId = lineNode.dataset.itemId;
        const variantCount = lineNode.dataset.itemCount;
        const accessoriesData = getCartItemAccessoriesData(lineNode);

        if (!variantCount) return;

        if (Object.keys(accessoriesData).length) {
          items.accessoriable_variant_ids = items.accessoriable_variant_ids || {};

          items.accessoriable_variant_ids[variantId] = items.accessoriable_variant_ids[variantId] || [];

          items.accessoriable_variant_ids[variantId].push({
            quantity: _round(_toFinite(variantCount), 3),
            accessory_value_ids: accessoriesData
          });
        } else {
          items[variantId] = _round(_toFinite(variantCount), 3);
        }
      });

      Cart.add({ items });

      EventBus.subscribe('add_items:insales:cart', () => {
        window.location.href = '/cart_items';
      });
    });
  });
};

export default _Singleton(CartDOM).getInstance();
